export default {"src":"/_next/static/media/replica.8e57af02.svg","height":16,"width":111};